import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { addCustomerUserToCurrentProject, handleRestoreUser, updateUserResource, updateB2CUserListInAtom } from '@/service/userService';
import { createFilterOptions } from '@material-ui/lab';
import { updateProjectDetail } from '@/service/projectService';
import { getTicketListBetweenProjectAndB2C, archiveTicketList, getTicketDataGSI3WithFilter, getTicketById } from '@/service/ticketService';

export const newProjectUserDefaultData = {
    id: Date.now().toString(),
    avatar: '',
    mail: '',
    lastName: '',
    firstName: '',
    phoneNumber: '',
    organizationName: '',
    isAddNew: true,
};


/**
 * addNewRowProjectUser
 * @param {*} userAddList 
 * @param {*} setUserAddList 
 */
export const addNewRowProjectUser = (userAddList, setUserAddList) => {
    let userProjectAddListClone = cloneDeep(userAddList);

    let newUserProject = { ...newProjectUserDefaultData };
    newUserProject.id = Date.now().toString();

    userProjectAddListClone.push(newUserProject);
    setUserAddList(userProjectAddListClone);
};



/**
 * isFillUserData
 * @param {*} list 
 * @param {*} id 
 * @returns 
 */
export const isFillUserData = (list, id) => {
    try {
        let listClone = cloneDeep(list);
        const indexOfItem = Utils.findIndexInArrayById(id, list);

        let status = false;

        for (let key in listClone[indexOfItem]) {
            if (['mail', 'firstName', 'lastName', 'phoneNumber', 'organizationName'].includes(key)) {
                if (typeof listClone[indexOfItem][key] !== 'string') {
                    throw new Error('List fields contain some elements which are not string type');
                }
                status = status | !Utils.isEmptyString(listClone[indexOfItem][key]);
            }
        }
        return status;
    } catch (err) {
        console.error({ PopupDeleteItem: err });
        return true;
    }
};


/**
 * reMoveRowProjectUser
 * @param {*} id 
 * @param {*} userAddList 
 * @param {*} setUserAddList
 */
export const reMoveRowProjectUser = (argsAll, id, userAddList, setUserAddList) => {
    let errorsList = argsAll.errors;
    let currentAddList = cloneDeep(userAddList);
    let hasErrorChanged = false;

    currentAddList = currentAddList.filter((e, i) => e.id !== id);
    let mailDuplicate = findMailDuplicate(currentAddList);
    let phoneDuplicate = findPhoneDuplicate(currentAddList);

    currentAddList.forEach(item => {
        // Clear mail duplicate errors
        if (
            !mailDuplicate.includes(item.mail.trim().toLowerCase()) &&
            !Utils.isEmptyString(errorsList[`${item.id}`]?.mail)
        ) {
            delete errorsList[`${item.id}`]?.mail;
            hasErrorChanged = true;
        }

        // Clear phone duplicate errors
        if (
            !phoneDuplicate.includes(item.phoneNumber?.trim()) &&
            !Utils.isEmptyString(errorsList[`${item.id}`]?.phoneNumber)
        ) {
            delete errorsList[`${item.id}`]?.phoneNumber;
            hasErrorChanged = true;
        }
    });

    if (hasErrorChanged) {
        argsAll.setErrors(errorsList);
    }

    setUserAddList(currentAddList);
};


/**
 * isDisplayPopupCancelAddOrEditChecker
 * Check if cancel confirmation popup should be displayed
 * @param {*} argsAll 
 * @returns boolean
 */
export const isDisplayPopupCancelAddOrEditChecker = argsAll => {
    if (!isEmptyUserAddList(argsAll) || isChangeDataEdited(argsAll)) {
        return true;
    }
    return false;
};


/**
 * onClickCancelEdit
 * @param {*} argsAll 
 */
export const onClickCancelEdit = (argsAll) => {
    if (isDisplayPopupCancelAddOrEditChecker(argsAll)) {
        return argsAll.setIsOpenModalConfirmCancel(true);
    }
    
    argsAll.setUserAddList([]);
    argsAll.setIsEditMode(false);
    
    let newCustomerList = argsAll.customerList.map(customer => {
        if (customer.isEditMode) {
            delete customer.isEditMode;
            customer.firstName = customer.originFirstName;
            customer.lastName = customer.originLastName;
            customer.organizationName = customer.originOrganizationName || '';
        }
        return customer;
    });
    
    argsAll.setCustomerList(newCustomerList);
    return;
};


/**
 * onSubmitCancelEdit
 * @param {*} argsAll 
 */
export const onSubmitCancelEdit = (argsAll) => {
    let userAddList = cloneDeep(argsAll.userAddList);
    let newCustomerList = cloneDeep(argsAll.customerList);
    
    userAddList = userAddList.map((item, index) => {
        return {
            ...item,
            usage: Constant.SYSTEM_USAGE_TYPE.USER,
            affiliationOrganization: argsAll.corporationId,
            mail: '',
            status: Constant.STATUS_OF_USER.WAITING,
            firstName: '',
            lastName: '',
            phoneNumber: '+81',
            organizationName: '',
            isAutocomplete: false
        }
    });
    
    newCustomerList = newCustomerList.map(customer => {
        if (customer.isEditMode) {
            delete customer.isEditMode;
            customer.firstName = customer.originFirstName;
            customer.lastName = customer.originLastName;
            customer.organizationName = customer.originOrganizationName || '';
        }
        return customer;
    });
    
    argsAll.setIsEditMode(false);
    argsAll.setCustomerList(newCustomerList);
    argsAll.setUserAddList(userAddList);
    argsAll.setErrors({});
    argsAll.setErrorEditUser({});
}

export const isEmptyUserAddList = argsAll => {
    let count = 0;
    let userAddLists = cloneDeep(argsAll.userAddList);
    for (let i = 0; i < userAddLists.length; i++) {
        let user = userAddLists[i];
        if (
            Utils.isEmptyString(user.mail) &&
            Utils.isEmptyString(user.firstName) &&
            Utils.isEmptyString(user.lastName) &&
            (Utils.isEmptyString(user.phoneNumber) || user.phoneNumber === Constant.DEFAULT_COUNTRY_CODE) &&
            Utils.isEmptyString(user.organizationName)
        ) {
            count += 1;
        }
    }
    return count === userAddLists.length;
};


/**
 * updateSuggestCustomerUserList
 * @param {*} customerUserList 
 * @param {*} argsAll 
 */
export const updateSuggestCustomerUserList = (customerUserList, argsAll) => {
    let suggestList = [];

    if (!Utils.isEmptyArray(customerUserList)) {
        // Sort customerUserList by created desc
        customerUserList = Utils.sortByCreatedAtDesc(customerUserList);

        customerUserList.forEach(userInfo => {
            suggestList.push({
                id: userInfo.id,
                mail: userInfo.mail,
                label: userInfo.mail
            })
        })
    }

    argsAll.setSuggestCustomerUserList(suggestList);
    argsAll.setDefaultSuggestCustomerUserList(suggestList);
}


/**
 * onSelectSugguestUser
 * @param {*} value 
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const onSelectSugguestUser = (value, argsAll, user) => {
    let selectedUserId = value.id;
    if (!selectedUserId) return;

    let selectedUserInfo = argsAll.customerListCanAdd.find(userDetail => userDetail.id === selectedUserId);
    if (Utils.isEmptyObject(selectedUserInfo)) return;

    let currentAddList = cloneDeep(argsAll.userAddList);
    let selectedIndexInList = Utils.findIndexInArrayById(user.id, currentAddList);
    if (selectedIndexInList === -1) return;

    currentAddList[selectedIndexInList].avatar = '';
    currentAddList[selectedIndexInList].mail = selectedUserInfo.mail;
    currentAddList[selectedIndexInList].lastName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, selectedUserInfo.lastName);
    currentAddList[selectedIndexInList].firstName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, selectedUserInfo.firstName);
    currentAddList[selectedIndexInList].phoneNumber = selectedUserInfo.tel || '';
    currentAddList[selectedIndexInList].organizationName = selectedUserInfo?.organizationName || '';
    currentAddList[selectedIndexInList].isAutocomplete = true;

    argsAll.setUserAddList(currentAddList);

    // Remove error 
    let currentError = cloneDeep(argsAll.errors);
    if (currentError.hasOwnProperty(user.id)) {
        delete currentError[user.id];
        argsAll.setErrors(currentError);
    }
}


export const filterSugguestionOption = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.label,
});

export const validateEmail = (email, userAddList, userId) => {
    let userAddListClone = cloneDeep(userAddList);
    let errors;
    // validate email
    if (Utils.isEmptyString(email?.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (!Utils.validateEmail(email)) {
        errors = I18n.get('COMM01MSG07');
    } else if (email?.trim().length > Constant.EMAIL_MAX_LENGTH) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', Constant.EMAIL_MAX_LENGTH);
    } else {
        let emails = userAddListClone.filter(x => x.id !== userId && x.mail.trim().toLowerCase() === email?.trim().toLowerCase());
        let isExistEmail = emails && emails.length > 0  ? true : false;
        if (isExistEmail) {
            errors = I18n.get('USER09MSG007');
        } else {
            errors = '';
        }
    }

    return errors;
};

export const validateNameUser = name => {
    let errors;
    if (Utils.isEmptyString(name?.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (name?.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200');
    } else {
        errors = '';
    }

    return errors;
};

export const validatePhoneNumber = phoneNumber => {
    let errors;
    if (Utils.isEmptyString(phoneNumber?.trim())) {
        errors = '';
    } else if (phoneNumber?.trim().length > 20) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '20');
    } else {
        errors = '';
    }

    return errors;
};

export const validateOrganizationName = organizationName => {
    let errors;
    if (Utils.isEmptyString(organizationName?.trim())) {
        errors = '';
    } else if (organizationName?.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200');
    } else {
        errors = '';
    }

    return errors;
};

export const findMailDuplicate = (userAddList) => {
    let valueArr = userAddList.map(item => item.mail.trim().toLowerCase()).filter(item => !!item);
    const mailDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return mailDuplicate;
}

export const findPhoneDuplicate = (userAddList) => {
    let valueArr = userAddList.map(item => item.phoneNumber?.trim()).filter(item => !!item);
    const phoneDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return phoneDuplicate;
}

export const onChangeEmail = (e, userId, argsAll) => {
    let email = e.target.value;

    let userAddList = cloneDeep(argsAll.userAddList);
    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);

    let errorsList = argsAll.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};

    let errors = validateEmail(email.trim(), userAddList, userId);
    if (!Utils.isEmptyString(errors)) {
        errorsRow.mail = errors;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd].mail = email;
        userAddList[indexAdd].isAutocomplete = false;
        argsAll.setUserAddList(userAddList);
    } else {
        delete errorsRow.mail;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd].mail = email;
        userAddList[indexAdd].isAutocomplete = false;
        argsAll.setUserAddList(userAddList);
    }

    let mailDuplicate = findMailDuplicate(userAddList);
    userAddList.forEach(item => {
        if (!mailDuplicate.includes(item.mail.trim().toLowerCase()) && errorsList[`${item.id}`]?.mail === I18n.get('USER09MSG007')) {
            delete errorsList[`${item.id}`]?.mail;
            argsAll.setErrors(errorsList);
        }
    });
};

export const onChangeNameUser = (e, userId, fieldName, argsAll) => {
    let nameValue = e.target.value;

    let userAddList = cloneDeep(argsAll.userAddList);
    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);

    let errorsList = argsAll.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};

    let errors = validateNameUser(nameValue);
    if (!Utils.isEmptyString(errors)) {
        errorsRow[`${fieldName}`] = errors;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd][`${fieldName}`] = nameValue;
        argsAll.setUserAddList(userAddList);
    } else {
        delete errorsRow[fieldName];
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd][`${fieldName}`] = nameValue;
        argsAll.setUserAddList(userAddList);
    }
};

export const onChangePhoneNumber = (phoneNumber, userId, argsAll) => {
    let userAddList = cloneDeep(argsAll.userAddList);
    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);

    let errorsList = argsAll.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};

    let errors = validatePhoneNumber(phoneNumber);
    if (!Utils.isEmptyString(errors)) {
        errorsRow.phoneNumber = errors;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);
    } else {
        delete errorsRow.phoneNumber;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);
    }

    userAddList[indexAdd].phoneNumber = phoneNumber || '';
    userAddList[indexAdd].isAutocomplete = false;
    argsAll.setUserAddList(userAddList);

    // Check phone duplicates
    let phoneDuplicate = findPhoneDuplicate(userAddList);
    
    // Set errors for all items have phone duplicate (from second item to latest item)
    phoneDuplicate.forEach(duplicatePhone => {
        let itemsWithThisPhone = userAddList.filter(item => 
            item.phoneNumber?.trim() === duplicatePhone
        );
        
        // Skip first item, set error for items from second item to latest item
        itemsWithThisPhone.forEach((item, idx) => {
            if (idx > 0) { // From second item to latest item
                if (!errorsList[`${item.id}`]) {
                    errorsList[`${item.id}`] = {};
                }
                errorsList[`${item.id}`].phoneNumber = I18n.get('USER09MSG011');
            }
        });
    });
    
    // Clear errors for items not have duplicate or is first item
    userAddList.forEach(item => {
        const isDuplicate = phoneDuplicate.includes(item.phoneNumber?.trim());
        const isFirstOccurrence = isDuplicate && 
            userAddList.findIndex(u => u.phoneNumber?.trim() === item.phoneNumber?.trim()) === 
            userAddList.findIndex(u => u.id === item.id);
        
        if ((!isDuplicate || isFirstOccurrence) && 
            errorsList[`${item.id}`]?.phoneNumber === I18n.get('USER09MSG011')) {
            delete errorsList[`${item.id}`]?.phoneNumber;
        }
    });
    
    argsAll.setErrors({...errorsList}); // Trigger re-render with new object
};

export const onChangeOrganizationName = (e, userId, argsAll) => {
    let organizationNameValue = e.target.value;

    let userAddList = cloneDeep(argsAll.userAddList);
    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);

    let errorsList = argsAll.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};

    let errors = validateOrganizationName(organizationNameValue);
    if (!Utils.isEmptyString(errors)) {
        errorsRow.organizationName = errors;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);
    } else {
        delete errorsRow.organizationName;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);
    }

    userAddList[indexAdd].organizationName = organizationNameValue;
    userAddList[indexAdd].isAutocomplete = false;
    argsAll.setUserAddList(userAddList);
};

/**
 * Check if required email is filled for users in edit mode
 * Users created from phone call must have email filled
 * @param {Object} argsAll - Context containing customerList
 * @returns {boolean} - true if all required emails are filled, false otherwise
 */
export const isRequiredEmailFilledInEditMode = argsAll => {
    for (const customer of argsAll.customerList) {
        // Only check customers in edit mode
        if (!customer.isEditMode) {
            continue;
        }

        // If user was created from phone call, email is required
        if (customer.isEmailFromPhoneCall) {
            const email = customer.mailAddress || Utils.getDisplayUserEmailWithoutSuffix(customer.mail) || '';
            if (Utils.isEmptyString(email.trim())) {
                return false;
            }
        }
    }
    return true;
};

/**
 * Set disable state for submit button based on add/edit mode and data/error status.
 * @param {Object} argsAll - Context containing userAddList, isEditMode, setIsDisableBtnSubmit, etc.
 */
export const checkDisableBtnSubmit = argsAll => {
    const isAddMode = isAddNewB2C(argsAll);
    const isEditMode = argsAll.isEditMode;

    // If not add mode and not edit mode, always disable
    if (!isAddMode && !isEditMode) {
        argsAll.setIsDisableBtnSubmit(true);
        return;
    }

    // Add mode only
    if (isAddMode && !isEditMode) {
        const hasValidationErrors = !Utils.isEmptyObject(validateUserAddList(argsAll.userAddList));
        argsAll.setIsDisableBtnSubmit(hasValidationErrors);
        return;
    }

    // Edit mode only
    if (isEditMode && !isAddMode) {
        const canSubmit = isChangeDataEdited(argsAll) && isEmptyErrorEditUsers(argsAll) && isRequiredEmailFilledInEditMode(argsAll);
        argsAll.setIsDisableBtnSubmit(!canSubmit);
        return;
    }

    // Both add and edit mode
    const canSubmit =
        isChangeDataEdited(argsAll) &&
        isEmptyErrorEditUsers(argsAll) &&
        isRequiredEmailFilledInEditMode(argsAll) &&
        Utils.isEmptyObject(validateUserAddList(argsAll.userAddList));
    return argsAll.setIsDisableBtnSubmit(!canSubmit);
};

export const validateUserAddList = (userAddList) => {
    if (Utils.isEmptyArray(userAddList)) return;

    let errors = {};
    userAddList.forEach(user => {
        errors[user.id] = {};

        let errorLastName = validateNameUser(user.lastName);
        if (!Utils.isEmptyString(errorLastName)) {
            errors[user.id].lastName = errorLastName;
        } else {
            delete errors[user.id].lastName;
        }

        let errorFirstName = validateNameUser(user.firstName);
        if (!Utils.isEmptyString(errorFirstName)) {
            errors[user.id].firstName = errorFirstName;
        } else {
            delete errors[user.id].firstName;
        }

        let errorEmail = validateEmail(user.mail?.trim(), userAddList, user.id);
        if (!Utils.isEmptyString(errorEmail)) {
            errors[user.id].mail = errorEmail;
        } else {
            delete errors[user.id].mail;
        }

        let errorPhoneNumber = validatePhoneNumber(user.phoneNumber);
        if (!Utils.isEmptyString(errorPhoneNumber)) {
            errors[user.id].phoneNumber = errorPhoneNumber;
        } else {
            delete errors[user.id].phoneNumber;
        }

        let errorOrganizationName = validateOrganizationName(user.organizationName);
        if (!Utils.isEmptyString(errorOrganizationName)) {
            errors[user.id].organizationName = errorOrganizationName;
        } else {
            delete errors[user.id].organizationName;
        }
    });

    // Check phone duplicates
    let phoneDuplicate = findPhoneDuplicate(userAddList);
    userAddList.forEach(user => {
        if (phoneDuplicate.includes(user.phoneNumber?.trim()) && !Utils.isEmptyString(user.phoneNumber?.trim())) {
            if (!errors[`${user.id}`]) {
                errors[`${user.id}`] = {};
            }
            errors[`${user.id}`].phoneNumber = I18n.get('USER09MSG011');
        }
    });

    let errorList = {};
    for(let key in errors) {
        if(!Utils.isEmptyObject(errors[key])) {
            errorList[key] = errors[key];
        }
    }
    
    return errorList;
}

export const handleSubmit = async argsAll => {
    try {
        // Validate add user list
        let userAddList = cloneDeep(argsAll.userAddList);
        let errors = validateUserAddList(userAddList);
        argsAll.setErrors(errors);
        
        if (!Utils.isEmptyObject(errors)) {
            return;
        }

        // Get users being edited
        let usersEditSubmit = argsAll.customerList.filter(
            user =>
                user.isEditMode &&
                (!Utils.isNotChangedName(
                    Constant.LANGUAGE_TYPE.JP,
                    user.firstName,
                    user.originFirstName
                ) ||
                    !Utils.isNotChangedName(
                        Constant.LANGUAGE_TYPE.JP,
                        user.lastName,
                        user.originLastName
                    ) ||
                    (user.organizationName || '') !== (user.originOrganizationName || ''))
        );

        // If only adding users (no edit), use existing add flow
        if (Utils.isEmptyArray(usersEditSubmit) && !Utils.isEmptyArray(userAddList)) {
            argsAll.setIsLoading(true);
            let customerUserListAdd = [];
            argsAll.userAddList.forEach(userAdd => {
                if (userAdd.mail && userAdd.firstName && userAdd.lastName) {
                    customerUserListAdd.push({
                        clientId: userAdd.id,
                        mail: userAdd.mail.trim(),
                        firstName: userAdd.firstName.trim(),
                        lastName: userAdd.lastName.trim(),
                        phoneNumber: userAdd.phoneNumber?.trim() || '',
                        organizationName: userAdd.organizationName?.trim() || '',
                    });
                }
            });

            let addCustomerResult = await addCustomerUserToCurrentProject(
                argsAll.API,
                argsAll.corporationId,
                argsAll.projectDetail.id,
                argsAll.userDetail.id,
                customerUserListAdd
            );
            
            if (!addCustomerResult || !addCustomerResult.status) {
                argsAll.setIsLoading(false);
                return;
            }

            if (!Utils.isEmptyArray(addCustomerResult.errorList)) {
                addCustomerResult.errorList.forEach(userError => {
                    const errorField = userError.error === 'ADD_CUSTOMER_PHONE_INVALID' ? 'phoneNumber' : 'mail';
                    errors[`${userError.clientId}`] = {
                        [errorField]: I18n.get(userError.error)
                    };
                });
            }

            argsAll.setErrors(errors);

            if (Utils.isEmptyArray(addCustomerResult.successList)) {
                argsAll.setIsLoading(false);
                return;
            }

            addCustomerResult.successList.forEach(userSuccess => {
                userAddList = userAddList.filter(userAdd => userAdd.id !== userSuccess.clientId);
            });
            
            argsAll.setIsAddNewUser(true);
            argsAll.setUserAddList(userAddList);
            argsAll.setTriggerReload(Date.now().toString());

            // Update B2C user list in Recoil atom for voice call feature
            if (argsAll.setListB2CUserListInOrg && argsAll.listB2CUserListInOrg) {
                // Get successfully added users from success list
                const successfullyAddedUsers = addCustomerResult.successList
                    .map(userSuccess => {
                        const addedUser = customerUserListAdd.find(u => u.clientId === userSuccess.clientId);
                        if (addedUser) {
                            return {
                                id: userSuccess.userId,
                                firstName: addedUser.firstName,
                                lastName: addedUser.lastName,
                                organizationName: addedUser.organizationName,
                                tel: addedUser.phoneNumber,
                                avatar: null
                            };
                        }
                        return null;
                    })
                    .filter(u => u !== null);
                
                updateB2CUserListInAtom(argsAll.listB2CUserListInOrg, successfullyAddedUsers, [], argsAll.setListB2CUserListInOrg);
            }
            return;
        }

        // If editing users (with or without add), use updateUserResource
        if (!Utils.isEmptyArray(usersEditSubmit)) {
            argsAll.setIsLoading(true);
            
            // Format add users
            let formattedUserAddList = [];
            if (!Utils.isEmptyArray(userAddList)) {
                formattedUserAddList = userAddList.map(addUserInfo => {
                    return {
                        ...addUserInfo,
                        mailAddress: addUserInfo.mail?.trim().toLowerCase(),
                        privilege: '',
                        userType: Constant.USER_TYPE.CUSTOMER,
                        firstName: addUserInfo.firstName?.trim(),
                        lastName: addUserInfo.lastName?.trim(),
                        phoneNumber: addUserInfo.phoneNumber?.trim() || '',
                        organizationName: addUserInfo.organizationName?.trim() || '',
                        affiliationOrganization: argsAll.corporationId
                    };
                });
            }

            // Combine add and edit lists
            let uniqueUserArray = [...formattedUserAddList, ...usersEditSubmit];

            let paramsUpdateUserList = {
                userList: JSON.stringify(uniqueUserArray),
                corporationId: argsAll.corporationId,
                actionFlag: Constant.CUSTOMERMANAGEMENT_ACTION_FLAG.CREATE_AND_UPDATE_CUTOMER_IN_CORP,
                idOfCurrentUser: argsAll.userDetail.id,
                projectId: argsAll.projectDetail.id
            };

            let result = await updateUserResource(argsAll.API, paramsUpdateUserList);
            
            if (!result || !result.status) {
                if (result?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
                    argsAll.setIsOpenModalReloadPage(true);
                } else if (result?.errorMessage && argsAll.setEditUserError) {
                    argsAll.setEditUserError(I18n.get(result?.errorMessage));
                } else if (result?.error) {
                    argsAll.enqueueSnackbar(I18n.get(result?.error), {
                        variant: 'error',
                        autoHideDuration: 3000
                    });
                }
                argsAll.setIsLoading(false);
                return;
            }

            // Handle errors for add users
            if (!Utils.isEmptyArray(userAddList) && result.status) {
                let addUserError = {};
                let listAddUserFail = [];
                const listUserAddFail = Utils.convertJSONDataToObject(result.userFailList);
                
                if (!Utils.isEmptyArray(listUserAddFail)) {
                    listUserAddFail.forEach(userFailInfo => {
                        let addUserInfo = userAddList.find(addUserInfoItem => {
                            return addUserInfoItem?.mail?.trim()?.toLowerCase() === userFailInfo?.email?.trim()?.toLowerCase();
                        });
                        
                        // only push user when found - avoid pushing undefined causing empty item
                        if (!Utils.isEmptyObject(addUserInfo)) {
                            listAddUserFail.push(addUserInfo);
                            const errorField = userFailInfo.errorCode === 'ADD_CUSTOMER_PHONE_INVALID' ? 'phoneNumber' : 'mail';
                            addUserError[addUserInfo.id] = {
                                [errorField]: I18n.get(userFailInfo.errorCode)
                            };
                        }
                    });
                }

                argsAll.setUserAddList([...listAddUserFail]);
                argsAll.setErrors({ ...addUserError });
            }

            // Handle errors for edit users
            if (!Utils.isEmptyArray(usersEditSubmit) && result.status) {
                let editUserError = cloneDeep(argsAll.errorEditUser) || {};
                let hasEditError = false;
                let updatedCustomerList = cloneDeep(argsAll.customerList);
                
                const listUserEditFail = Utils.convertJSONDataToObject(result.userFailList);
                
                if (!Utils.isEmptyArray(listUserEditFail)) {
                    listUserEditFail?.forEach(userFailInfo => {
                        let editUserInfo;
                        
                        // Find user by phone number if error is phone-related
                        if (userFailInfo.errorCode === 'ADD_CUSTOMER_PHONE_INVALID' && userFailInfo.phoneNumber) {
                            editUserInfo = usersEditSubmit.find(editUserInfoItem => {
                                return editUserInfoItem?.tel?.trim() === userFailInfo?.phoneNumber?.trim();
                            });
                        } else {
                            // Find user by email for other errors
                            editUserInfo = usersEditSubmit.find(editUserInfoItem => {
                                return editUserInfoItem?.mailAddress?.trim()?.toLowerCase() === userFailInfo?.email?.trim()?.toLowerCase();
                            });
                        }
                        
                        if (!Utils.isEmptyObject(editUserInfo)) {
                            hasEditError = true;
                            
                            // Initialize error object for this user if not exists
                            if (!editUserError[editUserInfo.id]) {
                                editUserError[editUserInfo.id] = {};
                            }
                            
                            // Handle email or phone errors from API
                            if (userFailInfo.errorCode === 'ADD_CUSTOMER_PHONE_INVALID') {
                                editUserError[editUserInfo.id].phoneNumber = I18n.get(userFailInfo.errorCode);
                            } else {
                                editUserError[editUserInfo.id].email = I18n.get(userFailInfo.errorCode);
                            }
                            
                            // Ensure failed users remain in edit mode
                            const customerIndex = updatedCustomerList.findIndex(c => c.id === editUserInfo.id);
                            if (customerIndex !== -1) {
                                updatedCustomerList[customerIndex].isEditMode = true;
                            }
                        }
                    });
                    
                    // Update state with errors
                    argsAll.setErrorEditUser({ ...editUserError });
                    
                    // If there are errors, stop here and let user fix them
                    if (hasEditError) {
                        argsAll.setCustomerList(updatedCustomerList);
                        argsAll.setIsLoading(false);
                        return;
                    }
                }
                
                // All edit users succeeded - exit edit mode
                updatedCustomerList = updatedCustomerList.map(customer => {
                    if (customer.isEditMode) {
                        delete customer.isEditMode;
                        // Update origin values for successfully edited users
                        customer.originFirstName = customer.firstName;
                        customer.originLastName = customer.lastName;
                        customer.originOrganizationName = customer.organizationName || '';
                    }
                    return customer;
                });
                argsAll.setCustomerList(updatedCustomerList);
                argsAll.setIsEditMode(false);
            }

            // Reload and show success message
            argsAll.setTriggerReload(Date.now().toString());
            argsAll.setIsLoading(false);
            
            let msgNoticeSuccess = I18n.get('MSG-CM-UPDATE-DATA-SUCCESS');
            argsAll.enqueueSnackbar(msgNoticeSuccess, {
                variant: 'success',
                autoHideDuration: 3000
            });

            // Update B2C user list in Recoil atom for voice call feature
            if (argsAll.setListB2CUserListInOrg && argsAll.listB2CUserListInOrg) {
                // Collect all successfully changed users (add + edit)
                let changedUsers = [];
                
                // Add successfully edited users
                if (!Utils.isEmptyArray(usersEditSubmit)) {
                    changedUsers = [...changedUsers, ...usersEditSubmit];
                }
                
                // Add successfully added users from userSuccessList
                if (result.userSuccessList) {
                    const userSuccessList = Utils.convertJSONDataToObject(result.userSuccessList);
                    if (!Utils.isEmptyArray(userSuccessList)) {
                        const successfullyAddedUsers = userSuccessList
                            .map(successUser => {
                                const addedUser = formattedUserAddList.find(u => 
                                    u.mailAddress?.toLowerCase() === successUser.mail?.toLowerCase()
                                );
                                if (addedUser) {
                                    return {
                                        id: successUser.id,
                                        firstName: addedUser.firstName,
                                        lastName: addedUser.lastName,
                                        organizationName: addedUser.organizationName,
                                        tel: addedUser.phoneNumber,
                                        avatar: null
                                    };
                                }
                                return null;
                            })
                            .filter(u => u !== null);
                        changedUsers = [...changedUsers, ...successfullyAddedUsers];
                    }
                }
                
                updateB2CUserListInAtom(argsAll.listB2CUserListInOrg, changedUsers, [], argsAll.setListB2CUserListInOrg);
            }
        }
    } catch (error) {
        console.error('Error in handleSubmit:', error);
        argsAll.enqueueSnackbar(I18n.get('COMMSG999'), {
            variant: 'error',
            autoHideDuration: 3000
        });
    } finally {
        // Ensure loading state is always reset
        if (argsAll.isLoading) {
            argsAll.setIsLoading(false);
        }
    }
};


/**
 * isDisableBtnDeleteProjectB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const isDisableBtnDeleteProjectB2C = (argsAll, user) => {
    if (!argsAll.userDetail || Utils.isEmptyObject(argsAll.userDetail)) {
        return true;
    }

    if (!user || Utils.isEmptyObject(user) || user.active === Constant.ACTIVE_FLAG.DELETED || user.activeInProject === Constant.ACTIVE_FLAG.DELETED) {
        return true;
    }

    return false;
}


/**
 * onClickDeleteProjectB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const onClickDeleteProjectB2C = async (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user) || user.active === Constant.ACTIVE_FLAG.DELETED || user.activeInProject === Constant.ACTIVE_FLAG.DELETED) {
        return;
    }

    argsAll.setIsOpenDialogConfirmDelete({
        isEnable: true,
        userId: user.id
    });
}


/**
 * handleDeleteProjectB2CUser
 * @param {*} argsAll 
 * @param {*} userId 
 * @returns 
 */
export const handleDeleteProjectB2CUser = async (argsAll, userId, userProjectId) => {
    if (!userId || !userProjectId) return;
    argsAll.setIsLoading(true);

    let objDeleteProjectB2C = {
        id: userProjectId,
        active: Constant.ACTIVE_FLAG.DELETED,
        type: Constant.PROJECT_TYPE.USER_CUSTOMER,
    }
    let deleteB2CResult = await updateProjectDetail(argsAll.API, userProjectId, objDeleteProjectB2C);
    if (!deleteB2CResult || !deleteB2CResult.id) {
        argsAll.setIsLoading(false);
        return;
    }

    // Archive ticket
    let getTicketListOfB2C = await getTicketListBetweenProjectAndB2C(
        argsAll.API,
        argsAll.corporationId,
        argsAll.projectId,
        userId
    );
    if (!Utils.isEmptyArray(getTicketListOfB2C)) {
        let allTicketOfUser = getTicketListOfB2C.filter(
            ticket =>
                ticket.public === Constant.TICKET_PUBLIC.PUBLIC &&
                ticket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.LIVE &&
                [
                    Constant.TICKET_TYPE.QA,
                    Constant.TICKET_TYPE.INTERNAL_QA,
                    Constant.TICKET_TYPE.EXTERNAL_QA,
                    Constant.TICKET_TYPE.DELEGATE,
                    Constant.TICKET_TYPE.BROADCAST_PARENT,
                    Constant.TICKET_TYPE.BROADCAST_CHILD
                ].includes(ticket.ticketType)
        );
        let ticketListToArchive = await prepareTicketListWithoutNoticeGroup(argsAll.API, allTicketOfUser);
        if (!Utils.isEmptyArray(ticketListToArchive)) {
            await archiveTicketList(argsAll.API, ticketListToArchive, argsAll.userDetail.id);
        }
    }

    let currentUserIndexInCustomerList = Utils.findIndexInArrayById(userId, argsAll.customerList);
    let currentCustomerList = cloneDeep(argsAll.customerList);
    currentCustomerList[currentUserIndexInCustomerList].activeInProject = Constant.ACTIVE_FLAG.DELETED;
    argsAll.setCustomerList(currentCustomerList);
    argsAll.setIsLoading(false);

    // Update B2C user list in Recoil atom for voice call feature (delete only marks as deleted in project, not in org)
    // No need to refresh B2C org list here since user is only deleted from project
}



/**
 * prepareTicketListWithoutNoticeGroup
 * @param {*} API 
 * @param {*} ticketList 
 * @returns 
 */
export const prepareTicketListWithoutNoticeGroup = async (API, ticketList) => {
    if (Utils.isEmptyArray(ticketList)) {
        return [];
    }

    try {
        let ticketListResult = [];

        await Promise.all(
            ticketList.map(async ticket => {
                if ([Constant.TICKET_TYPE.BROADCAST_CHILD, Constant.TICKET_TYPE.BROADCAST_PARENT].includes(ticket.ticketType)) {
                    let parentTicketId = ticket.id;
                    if (Constant.TICKET_TYPE.BROADCAST_CHILD === ticket.ticketType) {
                        parentTicketId = ticket.parent;
                    }

                    let parentTicketData = await getTicketById(API, parentTicketId);
                    if (parentTicketData.customer === 'NOTICE_CUSTOMER') {
                        let isNoticeGroup = await isNoticeGroupTicket(API, parentTicketId);
                        if (!isNoticeGroup) {
                            if (Constant.TICKET_TYPE.BROADCAST_CHILD === ticket.ticketType && Utils.findIndexInArrayById(ticket.id, ticketListResult) === -1) {
                                ticketListResult.push(ticket);
                            }
                            if (Utils.findIndexInArrayById(parentTicketData.id, ticketListResult) === -1) {
                                ticketListResult.push(parentTicketData);
                            }
                        }
                    } else if (
                        ![
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT,
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_GENERAL_PROJECT,
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_USER_IN_BASE_PROJECT
                        ].includes(parentTicketData.customer)
                    ) {
                        if (Constant.TICKET_TYPE.BROADCAST_CHILD === ticket.ticketType && Utils.findIndexInArrayById(ticket.id, ticketListResult) === -1) {
                            ticketListResult.push(ticket);
                        }
                        if (Utils.findIndexInArrayById(parentTicketData.id, ticketListResult) === -1) {
                            ticketListResult.push(parentTicketData);
                        }
                    }
                } else {
                    ticketListResult.push(ticket);
                }
            })
        );

        return ticketListResult;
    } catch (error) {
        console.log('prepareTicketListWithoutNoticeGroup error: ', error);
        return [];
    }
};


/**
 * isNoticeGroupTicket
 * @param {*} API 
 * @param {*} parentId 
 * @returns 
 */
export const isNoticeGroupTicket = async (API, parentId) => {
    let isNoticeGroup = false;

    let customerNoticeData = await getTicketDataGSI3WithFilter(
        API,
        parentId,
        Constant.TICKET_DATA_TYPE.FIELD,
        Constant.TICKET_DATA_ID.CUSTOMER_NOTICE
    );

    if (!Utils.isEmptyArray(customerNoticeData)) {
        let customerNoticeDataValue = JSON.parse(customerNoticeData[0].dataValue).value;
        let prefixOfId = Utils.getPrefixOfId(customerNoticeDataValue);
        if (prefixOfId !== 'user' && prefixOfId !== 'project') {
            switch (customerNoticeDataValue) {
                case Constant.NOTICE_ALL_CUSTOMER.ALL_CUSTOMER_PROJECT:
                case Constant.NOTICE_ALL_CUSTOMER.ALL_GUEST_CUSTOMER_USER:
                case Constant.NOTICE_ALL_CUSTOMER.ALL_GENERAL_PROJECT:
                case Constant.NOTICE_ALL_CUSTOMER.ALL_USER_IN_BASE_PROJECT:
                    isNoticeGroup = true;
                    break;
                default:
                    isNoticeGroup = false;
                    break;
            }
        } else {
            isNoticeGroup = false;
        }
    }

    return isNoticeGroup;
}


/**
 * isDisplayBtnRestoreB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const isDisplayBtnRestoreB2C = (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user)) {
        return false;
    }

    if ([Constant.STATUS_OF_USER.DELETED, Constant.STATUS_OF_USER.REJECT].includes(Utils.getB2CStatusInProject(user, user.activeInProject))) {
        return true;
    }

    return false;
}


/**
 * handleClickRestoreB2CInProject
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const handleClickRestoreB2CInProject = (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user)) {
        return;
    }

    argsAll.setSelectedUser(user);
    argsAll.setIsOpenDialogConfirmRestoreUser(true);
}


/**
 * onSubmitRestoreB2CInProject
 * @param {*} argsAll 
 * @returns 
 */
export const onSubmitRestoreB2CInProject = async (argsAll) => {
    if (!argsAll || !argsAll.selectedUser || Utils.isEmptyObject(argsAll.selectedUser)) return;

    let restoreUserId = argsAll.selectedUser.id;
    let restoreB2CRequestDto = {
        userId: restoreUserId,
        type: Constant.RESTORE_USER_TYPE.B2C_IN_PROJECT,
        projectId: argsAll.projectDetail.id,
        currentUserId: argsAll.userDetail.id
    }

    argsAll.setIsLoading(true);
    let restoreResult = await handleRestoreUser(argsAll.API, restoreB2CRequestDto);
    if (!restoreResult) {
        argsAll.setIsLoading(false);
        return;
    }

    if (!restoreResult.status) {
        argsAll.setIsLoading(false);
        if (!restoreResult?.errorMessage) {
            return;
        }

        if (restoreResult?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        } else if (argsAll.setEditUserError){
            argsAll.setEditUserError(I18n.get(restoreResult?.errorMessage))
        }
        return;
    }
    
    // Reload
    argsAll.setTriggerReload(Date.now().toString());
    argsAll.setIsLoading(false);
    argsAll.enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

    // Update B2C user list in Recoil atom for voice call feature (restore only marks as active in project, not in org)
    // No need to refresh B2C org list here since user is only restored in project
}


/**
 * isDisableBtnEditB2C
 * Check if Edit button should be disabled
 * Edit button is enabled only for users created from telephone
 * @param {*} argsAll 
 * @param {*} user 
 * @returns boolean
 */
export const isDisableBtnEditB2C = (argsAll, user) => {
    if (!argsAll.projectDetail || !argsAll.projectDetail.isDesk) {
        return true;
    }
    
    if (!user || Utils.isEmptyObject(user)) {
        return true;
    }
    
    if (user.activeInProject === Constant.ACTIVE_FLAG.DELETED) {
        return true;
    }

    // Only enable edit for users created from telephone
    const userSetting = Utils.convertJSONDataToObject(user.userSetting);
    if (!userSetting || userSetting.createdFromTelephone !== true) {
        return true;
    }
    
    return false;
};


/**
 * handleEdit
 * Enable edit mode for selected user
 * @param {*} user 
 * @param {*} args 
 */
export const handleEdit = (user, args) => {
    let customerList = cloneDeep(args.customerList);
    let errorEditUser = { ...args.errorEditUser };
    
    customerList = customerList.map(customer => {
        if (customer.id === user.id) {
            // Normalize the format by extracting and re-stringifying
            const currentFirstName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                customer.firstName
            );
            const currentLastName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                customer.lastName
            );
            
            // Save in consistent JSON format
            const normalizedFirstName = JSON.stringify({
                jp: {
                    A: 'F',
                    text: currentFirstName
                }
            });
            const normalizedLastName = JSON.stringify({
                jp: {
                    A: 'F',
                    text: currentLastName
                }
            });
            
            // Get display email without suffix
            const displayEmail = Utils.getDisplayUserEmailWithoutSuffix(customer.mail) || '';
            
            return Object.assign(customer, {
                isEditMode: true,
                firstName: normalizedFirstName,
                lastName: normalizedLastName,
                originFirstName: normalizedFirstName,
                originLastName: normalizedLastName,
                originOrganizationName: customer.organizationName || '',
                mailAddress: displayEmail
            });
        }
        return customer;
    });
    
    // Batch state updates to prevent multiple re-renders
    args.setCustomerList(customerList);
    args.setErrorEditUser(errorEditUser);
    args.setIsEditMode(true);
};


/**
 * isChangeDataEdited
 * Check if any data has been changed in edit mode
 * @param {*} argsAll 
 * @returns boolean
 */
export const isChangeDataEdited = argsAll => {
    let statusFlag = false;
    for (const customer of argsAll.customerList) {
        // Only check customers in edit mode
        if (!customer.isEditMode) {
            continue;
        }

        // Skip if origin values haven't been set yet (safety check)
        if (!customer.originFirstName || !customer.originLastName) {
            continue;
        }

        if (
            !Utils.isNotChangedName(
                Constant.LANGUAGE_TYPE.JP,
                customer.firstName,
                customer.originFirstName
            ) ||
            !Utils.isNotChangedName(
                Constant.LANGUAGE_TYPE.JP,
                customer.lastName,
                customer.originLastName
            ) ||
            (customer.organizationName || '') !== (customer.originOrganizationName || '')
        ) {
            statusFlag = true;
            break;
        }
    }
    return statusFlag;
};


/**
 * isEmptyErrorEditUsers
 * Check if there are no validation errors
 * @param {*} argsAll 
 * @returns boolean
 */
export const isEmptyErrorEditUsers = argsAll => {
    let statusFlag = true;
    if (Utils.isEmptyObject(argsAll.errorEditUser)) {
        return statusFlag;
    }
    for (let user in argsAll.errorEditUser) {
        if (!Utils.isEmptyObject(argsAll.errorEditUser[user])) {
            statusFlag = false;
        }
    }
    return statusFlag;
};


/**
 * isAddNewB2C
 * Check if there are new users being added
 * @param {*} argAll 
 * @returns boolean
 */
export const isAddNewB2C = argAll => {
    return Utils.isEmptyArray(argAll.userAddList) ? false : true;
};


/**
 * validateNameUserEditing
 * Validate firstName and lastName when editing
 * @param {*} event 
 * @param {*} name 
 * @returns error message or empty string
 */
export const validateNameUserEditing = (event, name) => {
    let errors;
    if (Utils.isEmptyString(name.trim())) {
        errors = I18n.get('COMMSG014'); 
    } else if (name.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200'); 
    } else {
        errors = '';
    }

    return errors;
};


/**
 * validatedOrganizationName
 * Validate organizationName when editing
 * @param {*} organizationName 
 * @returns error message or empty string
 */
export const validatedOrganizationName = organizationName => {
    let errors;
    if (Utils.isEmptyString(organizationName?.trim())) {
        errors = '';
    } else if (organizationName?.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200');
    } else {
        errors = '';
    }

    return errors;
};


/**
 * validatedEmail
 * Validate email field for edit mode
 * @param {*} email 
 * @param {*} userList 
 * @param {*} userId 
 * @returns error message or empty string
 */
export const validatedEmail = (email, userList, userId) => {
    let errors;
    // validate email
    if (Utils.isEmptyString(email.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (!Utils.validateEmail(email.trim())) {
        errors = I18n.get('COMM01MSG07');
    } else if (email.trim().length > Constant.EMAIL_MAX_LENGTH) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', Constant.EMAIL_MAX_LENGTH);
    } else if (email.trim().length < 4) {
        errors = I18n.get('COMMSG026').replace('{{minLength}}', 4);
    } else {
        // Check duplicate email
        let emails = userList.filter(x => {
            const userEmail = (x?.mail || '').trim().toLowerCase();
            return userEmail === email.trim().toLowerCase() && x.id !== userId;
        });
        let isExistEmail = emails && emails.length > 0 ? true : false;
        if (isExistEmail) {
            errors = I18n.get('USER09MSG007');
        } else {
            errors = '';
        }
    }
    return errors;
};


/**
 * validateEditUser
 * Handle onChange events when editing user
 * @param {*} event 
 * @param {*} userId 
 * @param {*} args 
 */
export const validateEditUser = (event, userId, args) => {
    let customerList = cloneDeep(args.customerList);
    let errorEditUser = args.errorEditUser;
    let inputValue = event.target.value;
    let errorsRow = errorEditUser[`${userId}`] ? errorEditUser[`${userId}`] : {};
    const index = Utils.findIndexInArrayById(userId, customerList);
    let errors = '';

    // Safety check
    if (index === -1) {
        return;
    }

    switch (event.target.id) {
        case `firstName-${userId}`: {
            errors = validateNameUserEditing(event, inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.firstName = errors;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            } else {
                delete errorsRow.firstName;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            }

            // Only update if value actually changed
            const currentFirstName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                customerList[index].firstName
            );
            if (currentFirstName !== inputValue) {
                customerList[index].firstName = JSON.stringify({
                    jp: {
                        A: 'F',
                        text: inputValue
                    }
                });
            }
            break;
        }
        case `lastName-${userId}`: {
            errors = validateNameUserEditing(event, inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.lastName = errors;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            } else {
                delete errorsRow.lastName;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            }

            // Only update if value actually changed
            const currentLastName = Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                customerList[index].lastName
            );
            if (currentLastName !== inputValue) {
                customerList[index].lastName = JSON.stringify({
                    jp: {
                        A: 'F',
                        text: inputValue
                    }
                });
            }
            break;
        }
        case `organizationName-${userId}`: {
            errors = validatedOrganizationName(inputValue);

            if (!Utils.isEmptyString(errors)) {
                errorsRow.organizationName = errors;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            } else {
                delete errorsRow.organizationName;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
            }

            customerList[index].organizationName = inputValue;
            break;
        }
        case `mailAddress-${userId}`: {
            errors = validatedEmail(inputValue, customerList, userId);
            
            if (!Utils.isEmptyString(errors)) {
                errorsRow.email = errors;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
                customerList[index].mailAddress = inputValue;
            } else {
                delete errorsRow.email;
                errorEditUser[`${userId}`] = errorsRow;
                args.setErrorEditUser(errorEditUser);
                customerList[index].mailAddress = inputValue;
            }
            break;
        }
        default:
            return;
    }

    args.setCustomerList(customerList);
};